import React, { FC } from 'react';
import { Box } from '@mui/material';
import { RegisterScreen } from './Register/RegisterScreen';
// import CompanyLogin from '../components/LoginScreenComponents/CompanyLogin';

const Register: FC = () => {
  return (
    <Box
      sx={{
        height: '100%',
        minHeight: '100vh',
        width: '100vw',
        textAlign: 'left',
      }}
    >
      <Box
        sx={{
          height: '100%',
          minHeight: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box>
          <RegisterScreen />
        </Box>
      </Box>
    </Box>
  );
};

export default Register;
